import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { Button } from "@/shared/ui/Button";
import styles from "./ReloadModal.module.scss";

export const ReloadModal = NiceModal.create(() => {
    const modal = useModal();
    const reload = () => {
        modal.remove();
        window.location.reload();
    };

    return (
        <div className={styles.reloadWindowWrapper}>
            <div className={styles.reloadWindow}>
                <div className={styles.reloadWindowInfo}>
                    Что-то пошло не так.
                    <br />
                    Пожалуйста перезагрузите страницу.
                </div>

                <Button fullWidth className={styles.reloadWindowAction} onClick={reload}>
                    Перезагрузить
                </Button>
            </div>
        </div>
    );
});
